import {Injectable} from '@angular/core';
import {
  AuthenticationService,
  IAuthorizationManager,
  ToastService,
  UserService,
  UserWithAuthorizations
} from '@cnj/uikit';
import {SisnorAuthService} from "./service/sisnor-auth-service";
import {environment} from "../app/environment";
import {SisnorUser} from "../app/models/sisno-user";

// Classe responsavel por receber as autorizações do usuário e verificar a existeência das mesmas
// Utilizando UserAuthorizationManager

@Injectable({
  providedIn: 'root'
})
export class SisnorAuthorizationManager implements IAuthorizationManager {
  constructor(
      protected userService: UserService,
      protected toastService: ToastService,
      protected authenticationService: AuthenticationService,
      protected sisnorAuthService: SisnorAuthService) {
  }

  public async authorize(action: string, resource: string): Promise<boolean> {
    const userWithAuthorizations = this.userService.userValue as any;
    if (userWithAuthorizations.authenticated) {

      const usuarioPossuiPermissao = userWithAuthorizations.authorizations.some(permissao => {
        const ehMesmoRecurso = permissao.resource === resource;
        const ehMesmaAcao = permissao.action.includes(action);

        return ehMesmoRecurso && ehMesmaAcao;
      });

      if (usuarioPossuiPermissao) {
        return true;
      }
    }
    return false;
  }

}
